import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { schema } from '@techstyle/redux-core';
import camelcaseKeys from 'camelcase-keys';
var httpRegex = /^http:/i; // Sometimes URL fields start with `http:`, which we can't display on HTTPS
// pages, so fix them up as early as possible.

var fixHttpFields = ['image_front', 'image_back', // Just in case.
'master_product_image_full_url', 'master_product_image_grid_url']; // From some endpoints (like ES search) these are number-strings like '1' or '0'
// instead of `true` or `false`.

var booleanFields = ['daily_fix_active', 'lead_only_flag', 'vip_elite_only_flag', 'elite_only_flag'];
export var MasterProduct = new schema.Entity('MasterProduct', {}, {
  idAttribute: 'master_product_id',
  // Summary of preprocessing:
  // - Convert everything from underscores to camelcase, except for
  //   `esImages.images` key names which are IDs, and
  //   `esImages.images.metadata.sizes` which are sizes like `300x300`.
  // - Manually correct `altmodel` and `altmodels` to `altModel` and
  //   `altModels`, respectively.
  processStrategy: function processStrategy(input) {
    var _input$esImages = input.esImages,
        esImages = _input$esImages === void 0 ? {} : _input$esImages,
        rest = _objectWithoutProperties(input, ["esImages"]);

    var _esImages$altmodels = esImages.altmodels,
        altModels = _esImages$altmodels === void 0 ? [] : _esImages$altmodels,
        _esImages$images = esImages.images,
        images = _esImages$images === void 0 ? {} : _esImages$images,
        esImagesRest = _objectWithoutProperties(esImages, ["altmodels", "images"]); // If we ever need to do this for more fields, make it an array of fields
    // later.


    if (rest.brand_id === '') {
      rest.brand_id = null;
    }

    fixHttpFields.forEach(function (key) {
      if (rest[key] != null) {
        rest[key] = rest[key].replace(httpRegex, 'https:');
      }
    });
    booleanFields.forEach(function (key) {
      if (typeof rest[key] === 'string') {
        rest[key] = rest[key] === '1';
      }
    });
    var output = camelcaseKeys(rest, {
      deep: true
    });
    output.esImages = _objectSpread(_objectSpread({}, camelcaseKeys(_objectSpread({
      altModels: altModels
    }, esImagesRest))), {}, {
      // These keys are IDs like `Chanel-H-01` so we can't touch them.
      images: Object.keys(images).reduce(function (newImages, key) {
        var imagesForKey = images[key] || [];
        newImages[key] = imagesForKey.map(function (image) {
          var newImage = camelcaseKeys(image, {
            deep: true,
            // These keys are image sizes like `300x300` and we don't want
            // to uppercase the `x` by accident.
            stopPaths: ['sizes']
          });

          if (newImage.metadata) {
            var _newImage$metadata = newImage.metadata,
                altModel = _newImage$metadata.altmodel,
                _rest = _objectWithoutProperties(_newImage$metadata, ["altmodel"]);

            newImage.metadata = _objectSpread({
              altModel: altModel
            }, _rest);
          }

          return newImage;
        });
        return newImages;
      }, {})
    });
    return output;
  }
});
export var ProductsPage = new schema.Object({
  products: new schema.Array(MasterProduct)
});